import React from "react";

export default function CompareSlider({ leftSrc, rightSrc, leftLabel = "Original", rightLabel = "Halftone" }) {
  const [pos, setPos] = React.useState(50);
  const ref = React.useRef(null);
  const dragging = React.useRef(false);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
    setPos((x / rect.width) * 100);
  };

  const onDown = () => (dragging.current = true);
  const onUp = () => (dragging.current = false);

  React.useEffect(() => {
    const mm = (e) => dragging.current && move(e.clientX);
    const tm = (e) => dragging.current && e.touches[0] && move(e.touches[0].clientX);
    window.addEventListener("mousemove", mm);
    window.addEventListener("touchmove", tm);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", mm);
      window.removeEventListener("touchmove", tm);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchend", onUp);
    };
  }, []);

  return (
    <div ref={ref} className="compare-slider aspect-[4/3] w-full select-none" onMouseDown={(e) => { onDown(); move(e.clientX); }} onTouchStart={(e) => { onDown(); e.touches[0] && move(e.touches[0].clientX); }}>
      <img src={rightSrc} alt="halftone" className="layer h-full w-full object-cover" draggable={false} />
      <div className="layer overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={leftSrc} alt="original" className="h-full w-full object-cover" draggable={false} style={{ width: `${(100 / pos) * 100}%`, maxWidth: "none" }} />
      </div>
      <div className="divider" style={{ left: `${pos}%` }} />
      <div className="handle" style={{ left: `${pos}%`, top: "50%" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 6 9 12 15 18"></polyline><polyline points="9 6 15 12 9 18"></polyline></svg>
      </div>
      <span className="absolute left-4 top-4 rounded-full border border-white/10 bg-black/60 px-3 py-1 text-xs text-white/90 backdrop-blur">{leftLabel}</span>
      <span className="absolute right-4 top-4 rounded-full border border-white/10 bg-black/60 px-3 py-1 text-xs text-white/90 backdrop-blur">{rightLabel}</span>
    </div>
  );
}
